export const events = {
	LOADING: "@onboardSimple/LOADING",
	CHANGE_LOADING: "@onboardSimple/CHANGE_LOADING",
	START_ONBOARD_REQUEST: "@onboardSimple/START_ONBOARD_REQUEST",
	START_ONBOARD_LOADING: "@onboardSimple/START_ONBOARD_LOADING",
	START_ONBOARD_SUCCESS: "@onboardSimple/START_ONBOARD_SUCCESS",
	START_ONBOARD_ERROR: "@onboardSimple/START_ONBOARD_ERROR",
	/**
	 * Eventos relaciondos ao cadastro dos clientes
	 */
	ON_NEW_CLIENT_FIELD_UPDATE_REQUEST: "@onboardSimple/ON_NEW_CLIENT_FIELD_UPDATE_REQUEST",
	ON_NEW_CLIENT_FIELD_UPDATE_LOADING: "@onboardSimple/ON_NEW_CLIENT_FIELD_UPDATE_LOADING",
	ON_NEW_CLIENT_FIELD_UPDATE_STATUS: "@onboardSimple/ON_NEW_CLIENT_FIELD_UPDATE_STATUS",
	/**
	 * Eventos relaciondos a compra
	 */
	ON_PROCESS_CLIENT_CHECKOUT_REQUEST: "@onboardSimple/ON_PROCESS_CLIENT_CHECKOUT_REQUEST",
	ON_CLIENT_CHECKOUT_LOADING: "@onboardSimple/ON_CLIENT_CHECKOUT_LOADING",
	ON_CLIENT_CHECKOUT_SUCCESS: "@onboardSimple/ON_CLIENT_CHECKOUT_SUCCESS",
	ON_CLIENT_CHECKOUT_SERVICE_ERROR: "@onboardSimple/ON_CLIENT_CHECKOUT_SERVICE_ERROR",

	DISPATCH_FORM_IS_VALID: "@onboardSimple/DISPATCH_FORM_IS_VALID",
	CHANGE_COLOR: "@onboardSimple/CHANGE_COLOR",

	VALIDATE_ONBOARDING: "@onboardSimple/VALIDATE_ONBOARDING",
	VALIDATE_ONBOARDING_STATUS: "@onboardSimple/VALIDATE_ONBOARDING_STATUS",

	IS_USER_REGISTERED_REQUEST: "@onboardSimple/IS_USER_REGISTERED_REQUEST",
	IS_USER_REGISTERED_DATA: "@onboardSimple/IS_USER_REGISTERED_DATA",

	TWYGO_INTEGRATION_DATA: "@onboardSimple/TWYGO_INTEGRATION_DATA",
	ONBOARDING_DATA_REQUEST: "@onboardSimple/ONBOARDING_DATA_REQUEST",
	ONBOARDING_DATA: "@onboardSimple/ONBOARDING_DATA",
	GOGOGO_REQUEST_STATUS: "@onboardSimple/GOGOGO_REQUEST_STATUS",

	TYPE_PRODUCT_RECURRENCE_DEFAULT: "@onboardSimple/TYPE_PRODUCT_RECURRENCE_DEFAULT",
	PRODUCT_DEFAULT: "@onboardSimple/PRODUCT_DEFAULT",

	CREATE_ONBOARD_BY_TOKEN_REQUEST: "@onboardSimple/CREATE_ONBOARD_BY_TOKEN_REQUEST",
	SET_NAME_AUTHENTICATED: "@onboardSimple/SET_NAME_AUTHENTICATED",
	SET_TOKEN_LOGIN: "@onboardSimple/SET_TOKEN_LOGIN",

	UPDATED_EMAIL: "@onboardSimple/UPDATED_EMAIL",

	UPDATE_CLIENT_ORIGIN: "@onboardSimple/UPDATE_CLIENT_ORIGIN",
	SET_UPDATED_CLIENT_ORIGIN: "@onboardSimple/SET_UPDATED_CLIENT_ORIGIN",

	IS_VERIFYING_DUPLICITY_EMAIL: "@onboardSimple/IS_VERIFYING_DUPLICITY_EMAIL",
	IS_UPDATING_EMAIL: "@onboardSimple/IS_UPDATING_EMAIL",

	RETRY_GET_CD_ACCESS_TOKEN: "@onboardSimple/RETRY_GET_CD_ACCESS_TOKEN",
	USER_REGISTERED_ONBOARD: "@onboardSimple/USER_REGISTERED_ONBOARD",
	IS_USER_REGISTERED: "@onboardSimple/IS_USER_REGISTERED",
};
